import axios from "axios";
import { IBooking, ILocation } from "../../types";

interface IInputSubstitutionParam {
    idRentalAgreement: string,
    subData: string
    bookingData: string
    caiModuloDenuncia: any,
    denunciaFurtoSmarrimento: any,
    ricevutaCarroattrezzi: any
}

export interface ISaveBookingParam {
    subData: {
        reason: string,
        eventDate: string,
        eventLocation: {
            eventPlaceCountry: string,
            eventPlaceCity: string,
            eventPlaceProvince: string,
            eventPlacePostalCode: string,
            eventPlaceStreetName: string,
            eventPlaceStreetNumber: string
        },
        eventDescription: string,
        vehicleAvailability: boolean,
        policeInvolved: boolean,
        notePoliceInvolved: string,
        substancesInfluence: boolean,
        dropoffDate: string,
        dropoffLocation: ILocation | null,
    },
    bookingData: {
        pickupLocation: ILocation | null,
        pickupDate: string | null,
        dropoffDate: string | null,
        dropoffLocation: ILocation | null,
    },
    caiModuloDenuncia: File | null,
    denunciaFurtoSmarrimento: File | null
    ricevutaCarroattrezzi: File | null
}

export const saveBookingSubstitution = async (params: IInputSubstitutionParam): Promise<IBooking> => {
    const response = await axios.postForm(`/booking/substitution`,
        {
            subData: params.subData,
            bookingData: params.bookingData,
            caiModuloDenuncia: params.caiModuloDenuncia,
            denunciaFurtoSmarrimento: params.denunciaFurtoSmarrimento,
            ricevutaCarroattrezzi: params.ricevutaCarroattrezzi
        },{
            params: {idRentalAgreement: params.idRentalAgreement
        },
    });
    return response.data;
};
